import Swiper from "swiper";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper.min.css";

SwiperCore.use(Navigation);

export default function DrinkSlider() {
  const swiper = new Swiper(".drink-slider__cards", {
    loop: true,
    navigation: {
      enabled: true,
      prevEl: ".drink-slider__prev",
      nextEl: ".drink-slider__next",
    },
  });
}
